export default __webpack_public_path__ + "24461985481c3df45a3f4f1a90270e7b.jpg";